import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalCommunicationPlan, {
    ModalCommunicationPlanModes
} from "root/Modals/CommunicationPlan/ModalCommunicationPlan";
import {validateMode} from "root/Modals/modalFunctions";

const useModalCommunicationPlan = (onSaveCompleted ) =>
{
    const defaultState =  { openState: false, mode: 'none', child_uid: null, ur_id: null, communications_plan_id: null  } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    const onClickActivate = ( { mode, child_uid, ur_id, communications_plan_id} ) =>
    {
        validateMode( mode, ModalCommunicationPlanModes ) ;

        setDialog ({ openState: true, child_uid: child_uid, ur_id: ur_id, mode: mode, communications_plan_id: communications_plan_id});
    }

    const onCloseModal = () =>
    {
        setDialog ( defaultState );
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ( defaultState );

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalCommunicationPlan ur_id={dialog.user_id_raw} child_uid={dialog.child_uid} communications_plan_id={dialog.communications_plan_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalCommunicationPlan ;
